module.exports = __webpack_public_path__ + "img/logo.b31ad293.png";